import React, { useState } from 'react';
import { useStateContext } from '../contexts/ContextProvider';
import { GeneralSettings, NotificationSettings, SecuritySettings, SettingsTab, PaymentSettings } from '../components';

const Settings = () => {
  const { school, currentColor, user } = useStateContext();
  const [activeTab, setActiveTab] = useState('General');
  const [schoolData, setSchoolData] = useState(school);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  // Handle tab switching
  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  // Update school data
  const updateSchoolData = (newData) => {
    setSchoolData(prev => ({
      ...prev,
      ...newData
    }));
  };

  // Render success or error message
  const renderMessage = () => {
    if (success) {
      return (
        <div className="fixed top-5 right-5 bg-green-500 text-white p-3 rounded-md shadow-md z-50">
          Settings saved successfully!
        </div>
      );
    }
    
    if (error) {
      return (
        <div className="fixed top-5 right-5 bg-red-500 text-white p-3 rounded-md shadow-md z-50">
          {error}
        </div>
      );
    }
    
    return null;
  };

  return (
    <div className="m-2 md:m-5 mt-24 p-4 md:p-6 lg:p-10 dark:bg-secondary-dark-bg bg-white rounded-3xl min-h-screen">
      <div className="flex justify-between items-center mb-6 md:mb-8">
        <h1 className="text-xl md:text-2xl font-bold">Settings</h1>
      </div>

      {/* Tabs */}
      <div className="mb-6 md:mb-8">
        <div className="relative">
          <div className="flex space-x-1 md:space-x-2 overflow-x-auto pb-2 scrollbar-hide">
            <div className="flex space-x-1 md:space-x-2 min-w-max">
              <SettingsTab 
                name="General" 
                active={activeTab === 'General'} 
                onClick={() => handleTabChange('General')} 
              />
              <SettingsTab 
                name="Notification" 
                active={activeTab === 'Notification'} 
                onClick={() => handleTabChange('Notification')} 
              />
              <SettingsTab 
                name="Security" 
                active={activeTab === 'Security'} 
                onClick={() => handleTabChange('Security')} 
              />
              <SettingsTab 
                name="Payment" 
                active={activeTab === 'Payment'} 
                onClick={() => handleTabChange('Payment')} 
              />
            </div>
          </div>
          {/* Scroll indicator for mobile */}
          <div className="md:hidden absolute right-0 top-0 bottom-2 w-8 bg-gradient-to-l from-white dark:from-secondary-dark-bg to-transparent pointer-events-none"></div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="border-t pt-8">
        {activeTab === 'General' && (
          <GeneralSettings 
            currentColor={currentColor} 
          />
        )}
        {activeTab === 'Notification' && (
          <NotificationSettings 
            schoolData={schoolData} 
            updateSchoolData={updateSchoolData} 
          />
        )}
        {activeTab === 'Security' && (
          <SecuritySettings 
            userId={user?._id} 
            schoolId={school?._id} 
          />
        )}
        {activeTab === 'Payment' && (
          <PaymentSettings 
            schoolData={schoolData} 
            updateSchoolData={updateSchoolData} 
          />
        )}
      </div>

      {renderMessage()}
    </div>
  );
};

export default Settings;